<template>
    <v-card width="100%">
        <v-card-title>
            <span>Настройки клиента загрузки</span>
        </v-card-title>
        <v-card-text>
            <v-card-subtitle>
                <span>Настройки скорости</span>
            </v-card-subtitle>
            <v-row>
                <v-col cols="12" md="4">
                    <v-row>
                        <v-col cols="1">
                            <v-checkbox v-model="torrentSettings['speed-limit-down-enabled']"/>
                        </v-col>
                        <v-col cols="11">
                            <v-text-field type="number"
                                          label="Ограничение скорости загрузки(постоянно)"
                                          :disabled="!torrentSettings['speed-limit-down-enabled']"
                                          suffix="Kb/s"
                                          v-model.number="torrentSettings['speed-limit-down']"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="1">
                            <v-checkbox v-model="torrentSettings['speed-limit-up-enabled']"/>
                        </v-col>
                        <v-col cols="11">
                            <v-text-field type="number"
                                          label="Ограничение скорости отдачи(постоянно)"
                                          :disabled="!torrentSettings['speed-limit-up-enabled']"
                                          suffix="Kb/s"
                                          v-model.number="torrentSettings['speed-limit-up']"/>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="4">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field type="number"
                                          label="Ограничение скорости загрузки(по расписанию)"
                                          suffix="Kb/s"
                                          v-model.number="torrentSettings['alt-speed-down']"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field type="number"
                                          label="Ограничение скорости отдачи(по расписанию)"
                                          suffix="Kb/s"
                                          v-model.number="torrentSettings['alt-speed-up']"/>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="4">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-checkbox label="Включить расписание"
                                        v-model="torrentSettings['alt-speed-time-enabled']"/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-checkbox label="Скорость по расписанию" v-model="torrentSettings['alt-speed-enabled']"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-menu ref="startTime" v-model="showStartTime"
                                    :close-on-content-click="false"
                                    :nudge-left="40"
                                    :return-value.sync="startTime"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="startTime" label="Начало" readonly v-bind="attrs" v-on="on"/>
                                </template>
                                <v-time-picker format="24hr" v-if="showStartTime" v-model="startTime" full-width
                                               @click:minute="$refs.startTime.save(startTime)"/>
                            </v-menu>
                        </v-col>
                        <v-col cols="6">
                            <v-menu ref="endTime" v-model="showEndTime"
                                    :close-on-content-click="false"
                                    :nudge-left="40"
                                    :return-value.sync="endTime"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="endTime" label="Окончание" readonly v-bind="attrs"
                                                  v-on="on"/>
                                </template>
                                <v-time-picker format="24hr" v-if="showEndTime" v-model="endTime" full-width
                                               @click:minute="$refs.endTime.save(endTime)"/>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row justify="space-around">
                        <v-checkbox class="mx-1" v-for="day in days" :label="day.name" :key="day.value"
                                    v-model="day.selected"/>
                    </v-row>
                </v-col>
            </v-row>
            <!--            <v-card-subtitle>-->
            <!--                <span>Остальные настройки</span>-->
            <!--                <v-row>-->
            <!--                    <v-col cols="12" md="4">-->
            <!--                    </v-col>-->
            <!--                </v-row>-->
            <!--            </v-card-subtitle>-->
        </v-card-text>
        <v-card-actions>
            <v-spacer/>
            <span class="mr-3 resultText">{{ result }}</span>
            <v-btn @click="save" small color="#cc7b19">Сохранить</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "torrentSettings",
    data() {
        return {
            showEndTime: false,
            showStartTime: false,
            startTime: '',
            result: '',
            days: [
                {name: 'пн', value: 10, selected: false, id: 1},
                {name: 'вт', value: 100, selected: false, id: 2},
                {name: 'ср', value: 1000, selected: false, id: 3},
                {name: 'чт', value: 10000, selected: false, id: 4},
                {name: 'пт', value: 100000, selected: false, id: 5},
                {name: 'сб', value: 1000000, selected: false, id: 6},
                {name: 'вс', value: 1, selected: false, id: 0}
            ],
            endTime: '',
            torrentSettings: [],
            params: ['alt-speed-time-end', 'speed-limit-down-enabled', 'speed-limit-down', 'speed-limit-up-enabled',
                'speed-limit-up', 'alt-speed-down', 'alt-speed-up', 'alt-speed-time-enabled', 'alt-speed-time-begin',
                'alt-speed-time-day', 'alt-speed-enabled']
        }
    },
    methods: {
        convertDay(int) {
            let bin = int.toString(2).split('').reverse()
            for (let i = 0; i < bin.length; i++) {
                if (bin[i] === '1') {
                    this.days.find(x => x.id === i).selected = true
                }
            }
        },
        convertTime(minute) {
            let hours = Math.trunc(minute / 60);
            let minutes = minute % 60;
            if (minutes < 10) minutes = '0' + minutes
            return hours + ':' + minutes;
        },
        async getTorrentSettings() {
            await this.$http.get('/getTorrentSettings').then((resp) => {
                this.torrentSettings = resp.data
                this.convertDay(this.torrentSettings['alt-speed-time-day'])
                this.startTime = this.convertTime(this.torrentSettings['alt-speed-time-begin'])
                this.endTime = this.convertTime(this.torrentSettings['alt-speed-time-end'])
            })
        },
        async save() {
            let startTime = this.startTime.split(':')
            this.torrentSettings['alt-speed-time-begin'] = parseInt(startTime[0]) * 60 + parseInt(startTime[1])
            let endTime = this.endTime.split(':')
            this.torrentSettings['alt-speed-time-end'] = parseInt(endTime[0]) * 60 + parseInt(endTime[1])
            let dayCount = 0
            for (let day of this.days) {
                if (day.selected) dayCount += day.value
            }
            this.torrentSettings['alt-speed-time-day'] = parseInt(dayCount.toString(), 2)
            Object.keys(this.torrentSettings).forEach((key) => this.params.includes(key) || delete this.torrentSettings[key]);
            await this.$http.post('/saveTorrentSettings', this.torrentSettings).then((resp) => {
                this.result = resp.data
            })
        }
    },
    created() {
        this.getTorrentSettings()
        this.$store.dispatch('updateToken')
    }
}
</script>

<style scoped>
.resultText {
    color: #00e676;
}
</style>